import { Outlet, Navigate } from "react-router-dom";
import { useAuthContext } from "contexts/AuthContext/context";

export default function PrivateRoute() {
  // Get partner
  const { authState } = useAuthContext();
  const { partner } = authState;

  // Render app or go to login
  return partner ? <Outlet /> : <Navigate to="/login" />;
}
